/**
 * Link Interaction Manager - Temporarily disables all link interactions on page load/transitions
 * by leveraging global CSS pointer-events blocking (default.vue), then injects a higher-specificity
 * rule after 850ms to restore interactivity, preventing navigation interruptions during transitions.
 * Implementation uses style tag injection for optimal performance with minimal DOM operations.
 */
export default defineNuxtPlugin(() => {
  setTimeout(() => {
    const style = document.createElement('style');
    style.innerHTML = `
      a {
        pointer-events: auto !important;
      }
    `;
    document.head.appendChild(style);
    console.log('[Plugin] Links re-enabled');
  }, 2600);
});
